import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DeadLetterDetail } from '../../models/dead-letter-detail.model';

@Component({
    selector: 'app-dead-letter-diagnostics-section',
    templateUrl: './dead-letter-diagnostics-section.component.html',
    styleUrls: ['./dead-letter-diagnostics-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterDiagnosticsSectionComponent {
  @Input() detail!: DeadLetterDetail;
  @Input() expanded = true;
  @Output() expandedChange = new EventEmitter<boolean>();
}
